exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".fct-fill-layout{display:-ms-flexbox;display:flex;-ms-flex-align:stretch;align-items:stretch;-ms-flex-pack:stretch;justify-content:stretch}.fct-fill-layout>*{position:relative;-ms-flex-positive:1;flex-grow:1;box-sizing:border-box;width:100%;min-height:100%;max-height:100%}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/autoprefixer-loader?browsers=last 2 version!./~/less-loader!./layout/fill/FillLayout.less
// module id = 174
// module chunks = 0